import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment'
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet'
import { dropdownIconW } from '../../resources/images'

class Resources extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
    }

    render() {
        return (
            <Fragment>
                <Helmet>
                    <title>QBank Landing Page</title>
                    <meta name="description" content="QBank landing allow user to know more about QBank Company background and also QBank products" />
                </Helmet>
                <div className="resourcesPage">
                    <div className="qbCard">
                        <div className="fTitle">MY ACTIVE RESOURCES</div>
                        <div className="resourcesCont">
                            <div className="itemCont">
                                <div className="headBox">
                                    <div className="dataCont">
                                        <div className="fLabel">Test</div>
                                        <div className="fCaption">Expired by: {moment().format('DD MMM YYYY')}</div>
                                    </div>
                                    <div className="qbBtn">ACCESS RESOURCES</div>
                                    <img src={dropdownIconW} alt="" className="dcIcon" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = ({ }) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Resources));


// WEBPACK FOOTER //
// ./src/Components/resources/Resources.js